<template>
  <div class="col-12 list-wrapper" style="height:100%;">
    <div class="col-12 col-xl-12 col-md-12" style="height: 100%;">
      <div class="row" v-if="!laborders || laborders.length == 0">
        <div class="col-12 text-center pt-3">
          {{ $t("message.No lab orders") }}
        </div>

      </div>

      <div v-if="laborders.length > 0" class="row laborder-list-container">
        <div class="col-12 col-lg-12">
          <!-- List for extra small devices -->
          <div class="row d-block d-md-block">
            <div class="col-12 laborder-list" v-for="(laborder) in laborders" :key="laborder.fileId">

              <div class="row align-items-center">
                <div class="col-2  col-lg-1">
                  <div class="lab-icon-container">
                    <div class="lab-icon-wrapper">
                      <i class="fa fa-microscope"></i>
                    </div>
                  </div>
                </div>
                <div class="col-10" @click="viewLaborder(laborder)">
                  <div class="reference-id">#{{ laborder.referenceId }}</div>
                  <div class="labtest-list">
                    <span v-for="(test, index) in laborder.labTests" :key="test._id">
                      {{ test.name }}
                      <span v-if="index != (laborder.labTests.length - 1)">, </span> </span>
                  </div>
                  <div class="laborder-status">
                    <span>{{ getLabOrderStatus(laborder.latestStatus) }}</span>
                  </div>
                  <div class="laborder-date">
                    {{ getFormattedDate(laborder.created) }}
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="pb-2 text-center create-button" :style="(!laborders || laborders.length < 1) ? { bottom: 'calc(100% - 50vh)' } : { bottom: '0' }">
        <n-button type="primary" round @click.native="bookLabOrder">
          <i class="fa fa-plus pr-2"></i>
          Book a Lab Test
        </n-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async mounted() {
    await this.getLaborders();

    if (this.laborders.length == 0) {
      this.$router.replace("booklabtest");
    }
  },
  data() {
    return {
      laborders: [],
    };
  },

  methods: {
    viewLaborder(laborder) {
      this.$router.push({
        path: "/viewlaborderdetails/" + laborder._id,
      });
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    getLabOrderStatus(status) {
      let msgVal = status;
      if (status == "Created") {
        msgVal = this.$t("message.Created");
      }
      if (status == "Accepted") {
        msgVal = this.$t("message.Accepted");
      }
      if (status == "Sample Collected") {
        msgVal = this.$t("message.Sample collected");
      }
      if (status == "Sample Deposited") {
        msgVal = this.$t("message.Sample deposited");
      }
      if (status == "Report Uploaded") {
        msgVal = this.$t("message.Report uploaded");
      }
      return msgVal;
    },
    async getLaborders() {
      this.laborders = (
        await this.$store.dispatch("getFilteredLaborders", {
          createdUser: this.user._id,
        })
      ).data;
    },
    bookLabOrder() {
      this.$router.push("booklabtest");
    },
  },
};
</script>


<style>
.lab-icon-wrapper {
  padding: 1em;
  border-radius: 50%;
  background: var(--color-primary);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2em;
  width: 2em;
  font-size: 1.5em;
  text-align: center;
}

.laborder-list-container {
  height: calc(100% - 50px);
  overflow: scroll;
}

.laborder-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-bottom: 1px solid #d6d0d0;
}

.laborder-list.selected {
  background-color: whitesmoke;
}

.labtest-list {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reference-id {
  font-size: 0.9em;
  font-weight: bold;
}

.labtest-list {
  margin-top: 0.5em;
}

.laborder-status {
  display: none;
}

.laborder-date {
  font-size: 0.6em;
  font-style: italic;
  color: grey;
  margin-top: 1em;
}

.create-button {
  position: fixed;
  top: auto;
  z-index: 200;
  left: 50%;
  transform: translateX(-50%);
}

/deep/ .has-success .form-control:focus + .input-group-addon {
  color: #555555;
}

/deep/ .el-input__inner {
  border-radius: 2em;
}
</style>

